import * as React from 'react';

export const TerminalIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1E252F"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="4 17 10 11 4 5" />
    <line x1="12" y1="19" x2="20" y2="19" />
  </svg>
);

export const DesktopMonitorIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#1E252F" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 21h21v-3h-21v3z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15zm0-3h-15V6h15v6z"
    />
  </svg>
);

export const CopyIcon: React.FC<{ color?: string; strokeWidth?: number | string }> = ({
  color = '#BDC4D5',
  strokeWidth = 2,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" style={{ stroke: color }} />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" style={{ stroke: color }} />
  </svg>
);

export const CheckmarkIcon: React.FC<{ strokeWidth?: number | string }> = ({ strokeWidth = 2 }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#29b5e8"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
